"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Wholesale integrations Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@deliverr.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.RejectionReason = void 0;
/**
 *
 * @export
 * @enum {string}
 */
exports.RejectionReason = {
    MISSING_RELATION_ID: 'missing_relation_id',
    OUT_OF_STOCK: 'out_of_stock',
    INVALID_LINE_ITEM: 'invalid_line_item',
    MISSING_CASE_PACK: 'missing_case_pack',
    DUPLICATE_PO_FILE: 'duplicate_po_file',
    MISSING_ORDER_QTY: 'missing_order_qty'
};
//# sourceMappingURL=rejection-reason.js.map